import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ethers } from 'ethers';
import { getProvider, getSigner, getContracts } from '../../lib/contracts';

function TokenSaleMeta() {
  const [account, setAccount]           = useState(null);
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [weiRaised, setWeiRaised]       = useState(null);
  const [error, setError]               = useState('');

  useEffect(() => {
    loadReadData();
  }, []);

  const loadReadData = async () => {
    try {
      const { crowdsale } = getContracts(getProvider());
      const period = await crowdsale.getCurrentPeriod();
      const raised = await crowdsale.getWeiRaised();
      setCurrentPeriod(Number(period));
      setWeiRaised(raised);
    } catch (e) {
      console.error('TokenSaleMeta loadReadData:', e);
    }
  };

  const connectWallet = async () => {
    setError('');
    try {
      const _signer  = await getSigner();
      const _account = await _signer.getAddress();
      setAccount(_account);
    } catch (e) {
      setError(e.message);
    }
  };

  const buy = async () => {
    setError('');
    try {
      const _signer = await getSigner();
      const { crowdsale } = getContracts(_signer);
      const tx = await crowdsale.contributeCurrentPeriod({
        value: ethers.parseEther('0.1'),
      });
      await tx.wait();
      loadReadData();
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div>
      <ToastContainer />

      {!account ? (
        <button onClick={connectWallet}>Connect Wallet</button>
      ) : (
        <p style={{ wordBreak: 'break-all' }}>Connected: {account}</p>
      )}

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {currentPeriod !== null && (
        <div>
          <div>Current Period: {currentPeriod}</div>
          <div>
            Total raised:{' '}
            {weiRaised !== null
              ? parseFloat(ethers.formatEther(weiRaised)).toFixed(4)
              : '—'}{' '}
            ETH
          </div>
        </div>
      )}

      <button onClick={buy}>Buy (0.1 ETH)</button>
    </div>
  );
}

export default TokenSaleMeta;
